"use client";

import { useEffect, useState } from "react";
import { ShareIcon } from "../icons";

/** The system share sheet where there is one; otherwise the link goes to the clipboard and says so. */
export function ShareButton({ url, title }: { url: string; title: string }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 2200);
    return () => clearTimeout(timer);
  }, [copied]);

  async function share() {
    if (typeof navigator.share === "function") {
      try {
        await navigator.share({ title, url });
      } catch {
        // Dismissed: nothing to do.
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
    } catch {
      // No clipboard access (insecure context): leave the page as it is.
    }
  }

  return (
    <span className="hf-share">
      <button type="button" className="hf-btn hf-btn-tone hf-btn-icon" aria-label="Share this room" onClick={share}>
        <ShareIcon />
      </button>
      <span className="hf-share-note" role="status" data-shown={copied ? "" : undefined}>
        {copied ? "Link copied" : ""}
      </span>
    </span>
  );
}
